import { Input, message, Modal } from "antd";
import { saveMemberLimit } from "api/partner";
import React, { useState } from "react";
import { Button } from "reactstrap";

function EditMemberLimit({ id, currentItemTotal, onClose, setDetails }) {
  const [membersLimit, setMembersLimit] = useState(null);

  const saveButton = async () => {
    if (membersLimit < currentItemTotal) {
      message.error("Members Limit cannot be less than current total");
      return;
    }
    await saveMemberLimit(id, membersLimit).then((res) => {
      if (res.message === "Updated") {
        message.success("Members Limit Updated Successfully");
      } else {
        message.error(res.message);
      }
      // getList();
    });
    setDetails((prev) => ({ ...prev, corporateMembersLimit: +membersLimit }));
    onClose();
  };

  return (
    <>
      <Modal onCancel={onClose} footer={[]} isOpen={true} visible={true}>
        <div>
          <div className="group">
            {/* <p className="">Members Limit</p> */}
            <label>
              Members Limit
              <span style={{ color: "red" }}> *</span>
            </label>
            <Input
              type="number"
              required
              // pattern="/^\d+$/"
              placeholder="Members Limit"
              value={membersLimit}
              onChange={(e) => {
                setMembersLimit(e.target.value);
              }}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={() => {
              saveButton();
            }}
            color="info"
            size="md"
            className="btn-round"
            style={{ marginTop: "40px" }}
          >
            Save
          </Button>
        </div>
        {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {!notification.isRead && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={continueButton}
                color="primary"
                size="md"
                className="btn-round"
              >
                Read
              </Button>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginLeft: "5px",
            }}
          >
            <Button
              onClick={() => {
                window.open(
                  `${notification.path}`,
                  "_blank"
                  // "noreferrer"
                );
              }}
              color="info"
              size="md"
              className="btn-round"
            >
              Go to link
            </Button>
          </div>
        </div> */}
      </Modal>
    </>
  );
}

export default EditMemberLimit;
